<v-one-alert></v-one-alert>
<v-one-inventory-warning-notification></v-one-inventory-warning-notification>
<router-outlet></router-outlet>
